 import { Controller } from "@hotwired/stimulus"

  export default class extends Controller {
    static targets = ["container"]

    connect() {
      this.element.classList.remove("translate-x-full", "opacity-0", "hidden", "pointer-events-none")
      this.element.setAttribute("aria-hidden", "false")
    }

    dismiss() {
      const el = this.element
      el.classList.add("opacity-0", "-translate-y-2", "pointer-events-none")
      el.classList.remove("opacity-100")

      const done = () => {
        el.classList.add("hidden")
        el.removeEventListener("transitionend", done)
      }

      el.addEventListener("transitionend", done, { once: true })
      setTimeout(done, 400)
    }
  }